import React, { useContext } from 'react'
import BodyText from 'components/Luxkit/Typography/BodyText'
import moment from 'moment'
import { DMY_CASUAL_FORMAT } from 'constants/dateFormats'
import ExperienceOfferPageTicketSelection from '../ExperienceOfferPage/ExperienceOfferPageTicketSelection'
import Modal from 'components/Luxkit/Modal/Modal'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ExperienceOfferPageStateContext from 'contexts/Experience/ExperienceOfferPage/experienceOfferPageStateContext'
import { useExperienceTicketsOptions } from 'hooks/ExperiencePage/useExperienceTicketsOptions'
import useExperienceAvailableTimes from 'hooks/ExperiencePage/useExperienceAvailableTimes'
import Caption from 'components/Luxkit/Typography/Caption'

interface Props {
  experienceView: App.ExperienceBookingView;
}

function ExperienceBnblModal(props: Props) {
  const {
    experienceView,
  } = props

  const pageState = useContext(ExperienceOfferPageStateContext)
  const { redemptionLocation, pickupPoint } = pageState
  const [slots] = useExperienceAvailableTimes(experienceView.originalExperience, {
    isBuyNowBookLater: true,
    redemptionLocationId: redemptionLocation?.id,
    pickupPointId: pickupPoint?.id,
  })
  const ticketOptions = useExperienceTicketsOptions(slots, { isBuyNowBookLater: true })

  const hasExpirationDates = !!(experienceView.originalExperience.bookByDate || experienceView.originalExperience.expirationDate)
  const showExpirationMessage = hasExpirationDates && !ticketOptions.some(ticket => ticket.bookByDate)

  return (
    <Modal
      title="Buy now, choose dates later"
      size="L"
    >
      <VerticalSpacer gap={16}>
        <VerticalSpacer gap={8}>
          <BodyText variant="large">This will secure the offer and give you the flexibility to choose your dates at a later time for all tickets.</BodyText>
          {showExpirationMessage && <BodyText variant="large">Please ensure you book by {moment(experienceView.originalExperience?.bookByDate ?? experienceView.originalExperience?.expirationDate).format(DMY_CASUAL_FORMAT)}{' '}
            for a date up to {moment(experienceView.originalExperience?.expirationDate).format(DMY_CASUAL_FORMAT)}.*
          </BodyText>}
          <Caption variant="medium">*Subject to availability and seasonal surcharges.</Caption>
        </VerticalSpacer>
        <ExperienceOfferPageTicketSelection
          experienceView={experienceView}
          isBuyNowBookLater
        />
      </VerticalSpacer>
    </Modal>
  )
}

export default ExperienceBnblModal
